import * as React from 'react';
import * as styles from './NoImage.css';
import { Image } from '../Image';

interface ICarouselProps {
  newbuildingId: number;
}

export const NoImage = ({ newbuildingId }: ICarouselProps) => {
  const noImageO1 = require('./assets/no_image_01.svg');
  const noImageO2 = require('./assets/no_image_02.svg');
  const noImageO3 = require('./assets/no_image_03.svg');

  const selectedImage = React.useMemo(() => {
    const images = [noImageO1, noImageO2, noImageO3];
    const index = newbuildingId % 3;

    return images[index];
  }, [newbuildingId, noImageO1, noImageO2, noImageO3]);

  return (
    <div className={styles['container']}>
      <Image noEmptyImage lazy src={selectedImage} objectFit="cover" />
    </div>
  );
};
